import { archiveActions } from './slice';
import { Action } from 'redux-saga';
export const fetchProjects = archiveActions.fetchProjects as (
  countries: string[],
) => Action;
export const unArchiveProjects = archiveActions.unArchiveProject as (
  projectIds: string[],
) => Action;
export const deleteProject = archiveActions.deleteProject as (
  payload: string,
) => Action;
